import styles from "../EventSubmissionFormV2/EventSubmissionFormV2.module.scss";
import v2Styles from "./EventSubmissionFormV2.module.scss";
import i18n from "../../i18n";
import PropTypes from "prop-types";
import {Form, Formik} from "formik";
import useLocalStorage from "./useLocalStorage";
import {getFormattedDate} from "./DateStep";
import {PrevButton, RecaptchaDisclaimer, Submit} from "./EventSubmissionFormV2";
import Loader from "../Loader";

export const getSelectedCategories = (categories, categoriesInLocalStorage) => {
    return categories
        .filter(category => categoriesInLocalStorage?.includes(category.value))
        .map(category => category.label)
}

const SummationStep = ({
   initialValues,
   validationSchema,
   categories,
   formValues,
   onClickPrev,
   onSubmit,
   showError,
   errorMessage,
}) => {
    const [data, setData, clearData] = useLocalStorage('eventData', {});
    const {
        titleEn,
        titleSv,
        descriptionEn,
        descriptionSv,
        externalWebsiteUrl,
        venueName,
        address,
        zip,
        city,
        image,
        photoCredit,
        startDate,
        endDate,
        date,
        startTime,
        endTime,
        location,
        categories: categoriesInLocalStorage,
        dateAdmin,
        submittedByEmail,
        consent,
    } = formValues;

    // TODO make so this isnt needed by storing the name directly in local storage/formValues
    const selectedCategories = getSelectedCategories(categories, categoriesInLocalStorage)

    const handleReloadPage = (e) => {
        e.preventDefault();
        window.location.reload();
    }
    
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >{({
               isSubmitting
           }) => (
            <Form className={styles['EventSubmissionFormV2__Summation']}>
                <div>
                    <div className={styles['EventSubmissionFormV2__Section']}>
                        {!!data.imageBase64 && (
                            <div className={styles['EventSubmissionFormV2__ImageWrapper']}>
                                <img className={styles['EventSubmissionFormV2__Image']}
                                     id="preview"
                                     src={data.imageBase64} alt=""/>
                            </div>
                        )}
                        <h2 className={styles['EventSubmissionFormV2__EventTitle']}>
                            {titleEn}
                        </h2>
                        {!!selectedCategories?.length && <p
                            className={styles['EventSubmissionFormV2__EventLabel']}
                            dangerouslySetInnerHTML={{
                                __html: selectedCategories.join(' &bull; '),
                            }}
                        />
                        }
                        <p className={styles['EventSubmissionFormV2__EventDescription']}>
                            {descriptionEn}
                        </p>
                        <h2 className={styles['EventSubmissionFormV2__EventTitle']}>
                            {titleSv}
                        </h2>
                        <p className={styles['EventSubmissionFormV2__EventDescription']}>
                            {descriptionSv}
                        </p>
                    </div>
                    <div className={
                        styles['EventSubmissionFormV2__Section']
                        + ' '
                        + styles['EventSubmissionFormV2__Section--Flex']}
                    >
                        <div className={styles['EventSubmissionFormV2__Column']}>
                            <h2 className={styles['EventSubmissionFormV2__MetaTitle']}>
                                {i18n.t(
                                    `EventSubmissionFormV2.summation.place`
                                )}
                            </h2>
                            <p className={
                                styles['EventSubmissionFormV2__Meta']
                                + ' '
                                + styles['EventSubmissionFormV2__Meta--Address']}
                            >
                                <span className={styles['EventSubmissionFormV2__Row']}>
                                    {address}
                                </span>
                                <span className={styles['EventSubmissionFormV2__Row']}>
                                    {zip} {city}
                                </span>
                            </p>
                            {externalWebsiteUrl && (
                                <a href={externalWebsiteUrl} className={styles['EventSubmissionFormV2__Meta']
                                    + ' '
                                    + styles['EventSubmissionFormV2__Meta--ExternalWebsite']}>
                                    {externalWebsiteUrl}
                                </a>
                            )}
                        </div>
                        <div className={styles['EventSubmissionFormV2__Column']}>
                            <h2 className={styles['EventSubmissionFormV2__MetaTitle']}>
                                {i18n.t(
                                    `EventSubmissionFormV2.summation.dates`
                                )}
                            </h2>
                            {!!dateAdmin?.length && dateAdmin.map((date, index) => {
                                return (
                                    date.type === 'single_date' ? (
                                        <p key={index} className={styles['EventSubmissionFormV2__Date']}>
                                            <span>{getFormattedDate(date.value.date, {showDayName: false})}</span>
                                            <span>{date.value.startTime} - {date.value.endTime}</span>
                                        </p>
                                    ) : (
                                        <p key={index}>
                                            {getFormattedDate(date.value.startDate, {showDayName: false})} - {getFormattedDate(date.value.endDate, {showDayName: false})}
                                        </p>
                                    )
                                );
                            })}
                        </div>
                    </div>
                    <div className={styles['EventSubmissionFormV2__Section']}>
                        <h2 className={
                            styles['EventSubmissionFormV2__MetaTitle']
                            + ' '
                            + styles['EventSubmissionFormV2__MetaTitle--Info']
                        }>
                            {i18n.t(
                                `EventSubmissionFormV2.summation.email`
                            )}
                        </h2>
                        <p className={styles['EventSubmissionFormV2__MetaInfo']}>
                            {i18n.t(
                                `EventSubmissionFormV2.summation.emailInfo`
                            )}
                        </p>
                        <p className={
                            styles['EventSubmissionFormV2__Meta']
                            + ' '
                            + styles['EventSubmissionFormV2__Meta--Email']}
                        >
                            {submittedByEmail}
                        </p>
                    </div>
                </div>
                <div className={v2Styles['EventSubmissionFormV2__ButtonsWrapper']}>
                    <PrevButton
                        onClick={onClickPrev}
                        disabled={isSubmitting}
                    />
                    {!!isSubmitting ? (
                        <Loader position="left"/>
                    ) : (
                        <Submit
                            text={i18n.t('EventSubmissionFormV2.buttons.submit')}
                            icon={false}
                        />
                    )}
                </div>
                {showError && (
                    <p className={styles['EventSubmissionFormV2__SubmissionError']}>
                        <span className={styles['EventSubmissionFormV2__Oops']}>
                            {i18n.t('EventSubmissionFormV2.error.oops')}
                        </span>
                        {i18n.t('EventSubmissionFormV2.error.text1')}
                        <a className={styles['EventSubmissionFormV2__ErrorLink']} href={"#"}
                           onClick={handleReloadPage}>
                            {i18n.t('EventSubmissionFormV2.error.refresh')}
                        </a>
                        {i18n.t('EventSubmissionFormV2.error.text2')}
                        <a className={styles['EventSubmissionFormV2__ErrorLink']}
                           href={'mailto: ' + i18n.t('EventSubmissionFormV2.error.contactMail')}>
                            {i18n.t('EventSubmissionFormV2.error.contactMail')}
                        </a>
                        {i18n.t('EventSubmissionFormV2.error.thanks')}
                    </p>
                )}
                <RecaptchaDisclaimer/>
            </Form>
        )}
        </Formik>
    )
}

export default SummationStep;
